import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const items = ['Sei stanco di perdere ore ogni settimana a cercare materiali sparsi su internet per costruire lezioni decenti.', 'Arrivi a casa dopo una lunga giornata e devi ancora metterti a preparare gli esercizi per il giorno dopo.', 'Senti di dare sempre gli stessi argomenti e i tuoi studenti hanno smesso di progredire davvero.', "Hai bisogno di mostrare risultati concreti con una struttura chiara, non con l'improvvisazione.", "Vuoi finalmente avere un sistema professionale che copra tutto l'anno — dal biennio al triennio — senza dover reinventare la ruota ogni settimana.", 'Hai studenti con livelli diversi (principianti, intermedi, avanzati) e non sai come gestirli tutti insieme.'];
export function ForYouChecklist() {
  return <section className="py-10 sm:py-12 px-4 bg-brand-card/50 border-y border-brand-orange/10 relative" data-id="element-106">
      <div className="max-w-4xl mx-auto" data-id="element-107">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-10 uppercase text-brand-cream" data-id="element-108">
          Questo sistema è per te se...
        </motion.h2>

        <div className="space-y-4" data-id="element-109">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex gap-4 items-start bg-brand-dark p-5 rounded-xl border border-white/5 hover:border-brand-orange/30 transition-colors" data-id="element-110">
              <CheckCircle2Icon className="w-6 h-6 sm:w-8 sm:h-8 text-green-500 shrink-0 mt-0.5" data-id="element-111" />
              <p className="text-base sm:text-lg text-gray-200 font-medium leading-relaxed" data-id="element-112">
                {item}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}